import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en';
import ja from '@/locales/ja';
import zh from '@/locales/zh';

/**
 * Translations.
 *
 * Keys are dotted and grouped by where they appear (`Nav.*`, `Common.*`, `Chuni.*`).
 * English is the fallback for every key, so a half-translated locale degrades to
 * English word by word rather than showing raw keys.
 */
export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ja', label: '日本語' },
  { code: 'zh', label: '简体中文' },
] as const;

const STORAGE_KEY = 'artemis.language';

function initialLanguage(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && LANGUAGES.some((language) => language.code === stored)) return stored;
  } catch {
    // Storage denied; fall through to the browser's own preference.
  }
  const base = (navigator.language ?? 'en').split('-')[0] ?? 'en';
  return LANGUAGES.some((language) => language.code === base) ? base : 'en';
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ja: { translation: ja },
    zh: { translation: zh },
  },
  lng: initialLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export function setLanguage(code: string): void {
  void i18n.changeLanguage(code);
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // The choice applies to this tab regardless; it just will not be remembered.
  }
}

export default i18n;
